//积分文案翻译

var point_error_server= 'Oops! A server error occured, please contact customer support.';//抱歉，服务器错误，请联系客服
var point_error_login= 'Please sign in first.';//请先登录
var point_add_error= 'Fail on issuing points, please contact support@ezink123.com';//加积分失败，请联系客服 support@ezink123.com
var point_add_error2= 'Fail on issuing points.';//加积分失败
var point_earn_more_points='Earn More Points.';//赚更多积分
var point_only_new_users_can_redeem='Only New Users can redeem';//只有新用户可以兑换
var point_only_existing_users_can_redeem='Only Existing Users can redeem';//只有现有用户可以兑换


var point_convert_success= 'Congrats! Product redeemed successfully.';//恭喜兑换产品成功！
var point_convert_success2= 'Redeemed successfully! Please check your Gift Card via E-Z in Points.';//兑换成功后，礼品卡或优惠码将于7个工作日内发送至您的电子邮件。
var point_shipments= 'Shipped';//状态：已发货
var point_redeemed= 'Redeemed';//状态：已兑换
var point_waiting_shipment= 'Waiting for shipment';//状态：等待发货
var point_successfully= 'successfully';//状态：成功
var point_processing= 'Processing';//处理中



var point_convert_title= 'Product Exchange';//积分兑换产品
var point_layer_confirm= 'Confirm';//确定
var point_layer_cancel= 'Cancel';//取消

var point_copied_invite_f= 'Copied! Invite friends now!';//复制成功，现在邀请好友

var point_recycling_title= 'Cartridge Recycling';//空壳回收


var point_complete_information_title= 'Profile Completed';//完善用户信息。


var point_complete_information_modify_successfully= 'Update Successfully!';//用户信息修改成功
var point_complete_information_modify_successfully2= 'Successfully updated! To win the points, please fill in all blank and submit again!';//用户信息修改成功

var point_account_registration='Account Registration';//注册用户

var point_community= 'Daily Community Visit';//每日浏览社区
var point_community2= 'Replying the Post';//社区留评
var point_community3= 'Posting an Article to Community Successfully';//社区发布文章
var point_login= 'Daily Check In';//每日登录
var point_following_twitter= 'Twitter Follow';//关注twitter
var point_following_facebook= 'Facebook Follow';//关注facebook
var point_follow_instagram= 'Instagram Follow';//关注instagram
var recommend_a_friend='recommend a friend';//推荐好友
var place_an_order='place an order';//下单加积分


var point_draw= 'Lucky Draw';//转盘抽奖
var point_draw_error= 'Oops! A server error occured, try again please.';//获得抽奖信息失败
var point_draw_insufficient= 'Your points is not enough for lucky draw';//用户积分不够抽奖
var point_draw_not_started= "The activity hasn't started yet.";//该活动尚未开始
var point_draw_finish= 'The activity ends.';//该活动已经结束


var point_amazon= 'Amazon warranty extension';//亚马逊延保
var point_amazon_repetition1= 'The order number you submitted is duplicate,please try another one.';//您提交的订单号已经注册，请用其他订单号提交
var point_amazon_repetition2= 'The order number you submitted is registered by other account, please submit with other order ID.';//您提交的订单号是由其他账户注册的，请使用其他订单号提交

